import React from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DetailsCardBody,
  DetailsList,
  DetailsListHeader,
} from "../../../shared/styles/Card.styles";
import NOTIFICATION_LIST_ITEM from "./Notification.renderer";
import NotificationsStyles from "./NotificationsCard.styles";
import { ICardProps } from "../Card.types";
import { isNullOrUndefined } from "../../../shared/utils/data.utils";
import {
  PackageNotificationSummary,
  GetPackageNotificationsResponse,
} from "../../../api/models";

const renderNotifications = (
  notifications: Array<PackageNotificationSummary>
): React.ReactNode => {
  return notifications.map((notification) => {
    return (
      <NOTIFICATION_LIST_ITEM
        notification={notification}
        key={notification.notificationId}
      />
    );
  });
};

const NOTIFICATIONS_CARD: React.FC<
  ICardProps<GetPackageNotificationsResponse>
> = (props: ICardProps<GetPackageNotificationsResponse>) => {
  const { subscription } = props;
  const { data, isLoading, isError } = subscription;

  return (
    <NotificationsStyles.NotificationsCard className="notifications-card">
      <DetailsListHeader
        className="details-list-header bordered"
        data-testid="notification-card-header"
      >
        <h4>Package Notifications</h4>
        <p>
          Packages are made up of Notifications, which include details about the
          work that will be performed.
        </p>
      </DetailsListHeader>
      <DetailsCardBody
        data-testid="notification-card-body"
        className="details-card-body"
      >
        {isLoading && !isError && (
          <div
            className="spinner-container"
            data-testid="notification-loading-spinner"
          >
            <FontAwesomeIcon
              icon={faSpinner}
              className="fa-spin"
              size="3x"
              color="#666666"
            />
          </div>
        )}
        {/* {isError && !isLoading && <div>{JSON.stringify(error)}</div>} */}
        {!isError &&
          !isLoading &&
          !isNullOrUndefined(data) &&
          !isNullOrUndefined(data.notifications) &&
          data.notifications.length && (
            <DetailsList className="details-list">
              {renderNotifications(data.notifications)}
            </DetailsList>
          )}
      </DetailsCardBody>
    </NotificationsStyles.NotificationsCard>
  );
};

export default NOTIFICATIONS_CARD;
